import React from 'react';
import PropTypes from 'prop-types';
// import IPLWidget from 'components_v2/mobile/IPLWidget';
import LoadableComponentLoader from 'components_v2/common/LoadableComponentLoader/LoadableComponentLoader';

import IPLWidgetV2 from 'components_v2/mobile/IPLWidget_v2';
import s from './LiveblogScoreCard.scss';

class LiveblogScoreCard extends React.Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
    };
  }

  showMiniScoreCard = (flag, eventName) => {
    this.setState({ loaded: flag, eventName });
  };

  componentDidMount() {}

  componentWillUnmount() {}

  componentDidUpdate() {}

  render() {
    const data = {
      autoUpadteTime: 30,
      cardsLinkout: false,
      autoRefresh: true,
      autoRefreshRate: 15000,
      // dataUrl: `https://toidev.indiatimes.com/feed_liveblogv2_mini_cricket_scorecard/msid-${
      //   this.props.msid
      // },feedtype-json.cms?upcache=2`,
      dataUrl: `https://toibnews.timesofindia.indiatimes.com/cricket/node/scorecardv2-${
        this.props.msid
      }.json`,
      ballbyballUrl: `https://toibnews.timesofindia.indiatimes.com/cricket/node/scorecard-${
        this.props.msid
      }.json`,
      gaCategory: 'SportsLiveblog_New',
      gaAction: 'click',
      gaLabel: 'miniScorecard',
      msid: this.props.msid,
    };
    return (
      <React.Fragment>
        <div
          className={`${
            this.state.loaded
              ? `${s.wrapper} contentwrapper clearfix`
              : `${s.wrapper} contentwrapper clearfix`
          } `}
        >
          <div
            className={`${s.scorecard_wrapper} ${this.props.isSportsCricketLB &&
              s.cricketlb}`}
          >
            <div
              className={
                this.props.microScoreCard
                  ? s.scorecard_top
                  : `${s.scorecard_top} ${s.placeholder}`
              }
            >
              {this.props.showWidgetHead &&
                !this.props.isWapView && (
                  <div className={s.header_top}>
                    <div
                      className={`${s.title} ${
                        this.props.ExternalClass ? this.props.ExternalClass : ''
                      }`}
                    >
                      {this.state.eventName}
                    </div>
                    {/* <div className={s.ads}>
                    Sponsored by{' '}
                    <img
                      src="https://static.toiimg.com/photo/81702917.cms"
                      title="Sponsored Ad"
                      alt="Sponsored Ad"
                    />
                  </div> */}
                  </div>
                )}
              {this.props.microScoreCard && (
                <IPLWidgetV2
                  {...data}
                  showMiniScoreCard={this.showMiniScoreCard}
                  isStickyCard
                />
              )}
              {!this.props.microScoreCard && (
                <LoadableComponentLoader
                  loadOnScroll={this.props.isWapView}
                  loadableComponentName="ScorecardWithAd"
                  {...data}
                  isWapView={this.props.isWapView}
                  showMiniScoreCard={this.showMiniScoreCard}
                />
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

LiveblogScoreCard.propTypes = {
  title: PropTypes.string,
  msid: PropTypes.string.isRequired,
  isAppView: PropTypes.bool,
  sponsorAd: PropTypes.string,
  isWapView: PropTypes.bool,
  showWidgetHead: PropTypes.bool,
  microScoreCard: PropTypes.bool,
};

LiveblogScoreCard.defaultProps = {
  title: '',
  isAppView: false,
  sponsorAd: '',
  isWapView: false,
  showWidgetHead: true,
  microScoreCard: false,
};

export default LiveblogScoreCard;
